import { Pipe, PipeTransform } from '@angular/core';

/**
 * brackets pipe
 *
 * Usage in the template file:
 * {{ 'my.key' | translate | brackets }}
 *
 */
@Pipe({
    name: 'brackets',
    standalone: false
})
export class BracketsPipe implements PipeTransform {
    /**
     *
     * @param string The string to wrap in brackets
     *
     * @returns updated string in brackets
     */
    transform(key: string): string {
        return `[${key}]`;
    }
}
